import { render, staticRenderFns } from "./editIssueCoupon.vue?vue&type=template&id=60453932&scoped=true"
import script from "./editIssueCoupon.vue?vue&type=script&lang=js"
export * from "./editIssueCoupon.vue?vue&type=script&lang=js"
import style0 from "./editIssueCoupon.vue?vue&type=style&index=0&id=60453932&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60453932",
  null
  
)

export default component.exports